<template>
  <li class="navigation__item">
    <router-link :to="{ name: route }">
      <Button
        :class="['navigation__button', { 'active': hasActiveClass(route) }]"
        :icon="`icon icon-${icon}`"
        type="text"
        is-navbar-button
      >
        {{ text }}
      </Button>
    </router-link>
  </li>
</template>

<script>
export default {
  props: {
    icon: String,
    isActive: Boolean,
    route: String,
    text: String,
  },
  methods: {
    hasActiveClass(route) {
      return route === this.$route.name;
    },
  },
};
</script>

<style lang="scss">
.navigation__button {
  &:hover,
  &:focus,
  &:active,
  &.active {
    color: $--color-primary-dark-3;
    text-decoration: underline !important;
  }
}

.navigation--vertical {
  .navigation__button {
    width: 100%;
    text-align: left;
    padding: 16px 20px;
    border-radius: 8px;

    &:hover,
    &:focus,
    &:active,
    &.active {
      text-decoration: none !important;
      background-color: $--color-background;
    }
  }
}
</style>
